<template>
	<el-dialog title="申请试用" :visible.sync="dialogVisible" width="601px" :before-close="handleClose" class="apply" :close-on-click-modal="false">
		<div class="applyPart">
			<el-form ref="form" :model="form" :rules="rules">
				<el-form-item prop="unitName"><el-input v-model.trim="form.unitName" placeholder="请输入单位名称" maxlength="20"></el-input></el-form-item>
				<el-form-item prop="name"><el-input v-model.trim="form.name" placeholder="请输入姓名称呼" maxlength="8"></el-input></el-form-item>
				<el-form-item prop="mobile"><el-input v-model.trim="form.mobile" placeholder="请输入手机号码" maxlength="11"></el-input></el-form-item>
				<el-row type="flex" justify="space-between">
					<el-col :span="16" class="inputW">
						<el-form-item><el-input v-model.trim="form.erifCode" placeholder="请输入验证码"></el-input></el-form-item>
					</el-col>
					<el-col :span="8" class="colw"><img :src="imgCodeUrl" alt="" @click="refreshCaptcha" /></el-col>
				</el-row>
				<el-row type="flex" justify="space-between">
					<el-col :span="16" class="inputW">
						<el-form-item><el-input v-model.trim="form.sMScode" placeholder="短信验证码"></el-input></el-form-item>
					</el-col>
					<el-col :span="8" class="colw">
						<!--						<el-button type="warning">点击获取验证码</el-button>-->
						<div class="getVali curpointer" v-show="canClick" @click.stop="getVali">点击获取验证码</div>
						<div class="timesout" v-show="!canClick">{{ second }}秒</div>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div class="lines"></div>
		<span slot="footer" class="dialog-footer"><el-button type="primary" @click="addbtn" class="addbtn">申 请 试 用</el-button></span>
	</el-dialog>
</template>

<script>
import rules from '@/util/rules.js';
import trialApi from '@/api/trial';

export default {
	data() {
		var checkPone = (rule, value, callback) => {
			let reg = /^1[3456789]\d{9}$/;
			if (!reg.test(value)) {
				return callback(new Error('请输入正确的手机号'));
			} else {
				callback();
			}
		};
		return {
			canClick: true,
			second: 60,
			stopClick:false,
			dialogVisible: false,
			form: {
				unitName: '',
				name: '',
				mobile: '',
				erifCode: '',
				sMScode: ''
			},
			rules: {
				unitName: [
					{
						required: true,
						message: '请输入单位名称',
						trigger: 'blur'
					},
					{
						validator: rules.FormValidate.Form().validateCAndE,
						trigger: 'blur'
					}
				],
				name: [
					{
						required: true,
						message: '请输入姓名称呼',
						trigger: 'blur'
					},
					{
						validator: rules.FormValidate.Form().validatecAndEN,
						trigger: 'blur'
					}
				],
				mobile: [
					{
						required: true,
						message: '请输入手机号码',
						trigger: 'blur'
					},
					{
						validator: checkPone,
						trigger: 'blur'
					}
				],
				erifCode:[
					{
						required: true,
						message: '请输入图片验证码',
						trigger: 'blur'
					}
				],
				sMScode:[
					{
						required: true,
						message: '请输入短信验证码',
						trigger: 'blur'
					}
				]
			},
			imgCodeUrl: 'jiance/trial/getCaptchaImg?' + Math.ceil(Math.random() * 1000)
		};
	},
	created() {

	},
	methods: {
		refreshCaptcha() {
			let num = Math.ceil(Math.random() * 1000);
			this.imgCodeUrl = 'jiance/trial/getCaptchaImg?' + num;
		},
		getVali() {
			if(this.stopClick) return false
			clearInterval(this.timer);
			this.stopClick = true
			let that = this;
			that.second = 60;
			that.$refs['form'].validate(valid => {
				if (valid) {
					if(that.form.erifCode.trim() === ''){
						this.$message.error('请输入图片验证码');
						this.stopClick = false
						return false
					}
					trialApi
						.sendVerifyCode({
							mobile: that.form.mobile,
							captcha: that.form.erifCode
						})
						.then(res => {
							if (res.returnCode == '1001') {
								that.canClick = false;
								that.timer = setInterval(() => {

									if (that.second === 0) {
										that.second = 60;
										clearInterval(this.timer);
										that.canClick = true;
									} else {
										that.second--;
									}
								}, 1000);
							}else{
								this.$message.error(res.returnMsg);
								that.refreshCaptcha();
							}
							this.stopClick = false
						});
				} else {
					this.stopClick = false
					return false;
				}
			});
		},
		handleClose(done) {
			/* this.$confirm('确认关闭？')
				   .then(_ => {
				     done();
				   })
				   .catch(_ => {}); */
			this.$refs['form'].resetFields();
            clearInterval(this.timer);
			this.$reset('form', ['rules']);
			this.dialogVisible = false;
		},
		addbtn() {
			let that = this;

			that.$refs['form'].validate(valid => {
				if (valid) {
					if(that.form.erifCode.trim() === ''){
						 this.$message.error('请输入图片验证码');
						return false
					}
					if(that.form.sMScode.trim() === ''){
						this.$message.error('请输入短信验证码');
						return false
					}
					that.applyPost()
				} else {

					return false;
				}
			});
		},

	    applyPost(){
			let that = this;
			trialApi
				.save({
					curname: that.form.unitName,
					userName: that.form.name,
					mobile: that.form.mobile,
					captcha: that.form.erifCode,
					verifyCode: that.form.sMScode
				})
				.then(res => {
					if (res.returnCode == '1001') {
						that.canClick = false;
						that.success();
					}else if(res.returnCode == '4001'){
                        that.$my_confirm(res.returnMsg,{type: 'warning'})
					}else{
                        this.$message.error(res.returnMsg);
					}
					that.refreshCaptcha();
				});
		},
		success() {
			this.$emit('success');
			this.handleClose();
		}
	},
	watch: {
		dialogVisible: {
			handler: function(val, oldval) {
				if (val) {
				}
			},
			deep: true //对象内部的属性监听，也叫深度监听
		}
	}
};
</script>

<style lang="less">
.getVali {
	width: 140px;
	height: 40px;
	background-color: #ffa81e;
	border-radius: 3px;
	font-family: MicrosoftYaHei;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 1px;
	color: #ffffff;
	float: right;
	text-align: center;
	line-height: 40px;
}

.timesout {
	width: 140px;
	height: 40px;
	background-color: #ffcb78;
	border-radius: 3px;
	border: solid 1px #ffaf31;

	font-family: MicrosoftYaHei;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;

	letter-spacing: 1px;
	color: #ffffff;
	text-align: center;
	line-height: 40px;
}

.apply {
	.align-right {
		text-align: right;
	}

	.el-dialog {
		padding-bottom: 65px;
	}

	.el-dialog .el-dialog__body {
		padding: 0px 58px;

		.applyPart {
			padding: 65px 67px 0px 67px;
		}

		.inputW {
			width: 199px;
		}

		.colw {
			width: 140px;
		}
	}

	.lines {
		height: 2px;
		background-color: #dde8f2;
	}

	.addbtn {
		width: 350px;
		margin-top: 43px;
	}
	.el-dialog .el-dialog__footer {
		padding: 0px;
	}
}
</style>
